import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=7c9ae794&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=ts&"
export * from "./InputTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=7c9ae794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9ae794",
  null
  
)

component.options.__file = "InputTextarea.vue"
export default component.exports